import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CodeInputs = styled(Stack)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    gap: theme.spacing(4),
    flexDirection: "row",
}));

export const ErrorWrapper = styled(Stack)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

export const CodeInputWrapper = styled(Stack)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& input": {
        fontSize: "20px",
        fontWeight: theme.typography.fontWeightBold,
        textAlign: "center",
        padding: theme.spacing(1),
        width: "48px",
        height: "64px",
        boxSizing: "border-box",
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px",
            padding: theme.spacing(1),
            width: "30px",
            height: "40px",
        },
    },
}));
